module.exports = __webpack_public_path__ + "img/fiery.de1b8ec8.svg";